import { CheckIcon } from 'lucide-react';
import type { ComponentProps } from 'react';
import { memo } from 'react';

import { ProfileNonToxicIcon } from '@/features/profile/components/profileNonToxicIcon';
import { cn } from '@/shared/utils/cn';

const iconTransformations = [
  {
    width: 24,
    height: 24,
  },
];

export interface ProfileNonToxicTierItemProps extends ComponentProps<'div'> {
  label: string;
  tier: number;
  isActive: boolean;
  isCurrentTier?: boolean;
  requirement: string;
  altRequirement?: string;
}

export const ProfileNonToxicTierItem = memo(function ProfileNonToxicTierItem({
  label,
  tier,
  isActive,
  isCurrentTier = false,
  requirement,
  altRequirement,
  className,
  ...rest
}: ProfileNonToxicTierItemProps) {
  return (
    <div className={cn('flex items-center gap-2.5', className)} {...rest}>
      <div className="relative shrink-0">
        <div
          className={cn(
            'bg-cold-900 flex items-center justify-center rounded-full border-2 p-2.5',
            isCurrentTier ? 'border-positive-500' : 'border-cold-800',
          )}
        >
          <ProfileNonToxicIcon
            className="size-6"
            transformations={iconTransformations}
            tier={tier}
          />
        </div>
        {isActive && (
          <div className="bg-positive-500 absolute -right-0.5 -bottom-0.5 flex size-4 items-center justify-center rounded-full">
            <CheckIcon className="size-2.5 text-white" strokeWidth={3} />
          </div>
        )}
      </div>

      <div className="flex min-w-0 flex-1 items-center justify-between gap-2">
        <p
          className={cn(
            'shrink-0 text-xs leading-none font-extrabold',
            isCurrentTier ? 'text-positive-500' : 'text-cold-500',
          )}
        >
          {label}
        </p>
        <div className="flex flex-col items-end gap-0.5">
          <p
            className={cn(
              'text-right text-xs leading-none font-medium',
              isCurrentTier ? 'text-positive-500' : 'text-cold-500',
            )}
          >
            {requirement}
          </p>
          {altRequirement && (
            <p
              className={cn(
                'text-right text-xs leading-none font-medium',
                isCurrentTier ? 'text-positive-500' : 'text-cold-500',
              )}
            >
              {altRequirement}
            </p>
          )}
        </div>
      </div>
    </div>
  );
});
